import { LegalPageLayout } from '../components/LegalPageLayout'

export default function ImpressumPage() {
  return (
    <LegalPageLayout title="Impressum">
      <h1>Impressum</h1>
      <p className="legal-last-updated">Angaben gemäß DDG § 5</p>

      <p>
        Kwame Ofori
        <br />
        Beckstraße 20
        <br />
        20357 Hamburg
        <br />
        Deutschland
      </p>

      <h2>Kontakt</h2>
      <p>
        E-Mail: <a href="mailto:contact@beahead.ai">contact@beahead.ai</a>
      </p>

      <h2>Verantwortlich für den Inhalt nach § 18 Abs. 2 MStV</h2>
      <p>
        Kwame Ofori
        <br />
        (Anschrift wie oben)
      </p>

      <h2>EU-Streitschlichtung</h2>
      <p>
        Die Europäische Kommission stellt eine Plattform zur
        Online-Streitbeilegung (OS) bereit:{' '}
        <a
          href="https://ec.europa.eu/consumers/odr/"
          target="_blank"
          rel="noopener noreferrer"
        >
          https://ec.europa.eu/consumers/odr/
        </a>
        .
        <br />
        Unsere E-Mail-Adresse finden Sie oben im Impressum.
      </p>
      <p>
        Wir sind nicht bereit oder verpflichtet, an
        Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle
        teilzunehmen.
      </p>

      <h2>Haftungsausschluss</h2>

      <p>
        <strong>Haftung für Inhalte</strong>
      </p>
      <p>
        Als Diensteanbieter sind wir gemäß DDG § 7 Abs. 1 für eigene Inhalte
        auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich. Nach
        DDG §§ 8 bis 10 sind wir als Diensteanbieter jedoch nicht
        verpflichtet, übermittelte oder gespeicherte fremde Informationen zu
        überwachen oder nach Umständen zu forschen, die auf eine
        rechtswidrige Tätigkeit hinweisen.
      </p>

      <p>
        <strong>Haftung für Links</strong>
      </p>
      <p>
        Unser Angebot enthält Links zu externen Websites Dritter, auf deren
        Inhalte wir keinen Einfluss haben. Für die Inhalte der verlinkten
        Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten
        verantwortlich. Eine permanente inhaltliche Kontrolle der verlinkten
        Seiten ist ohne konkrete Anhaltspunkte einer Rechtsverletzung nicht
        zumutbar.
      </p>

      <p>
        <strong>Urheberrecht</strong>
      </p>
      <p>
        Die durch den Seitenbetreiber erstellten Inhalte und Werke auf
        diesen Seiten unterliegen dem deutschen Urheberrecht. Die
        Vervielfältigung, Bearbeitung, Verbreitung und jede Art der
        Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der
        schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers.
      </p>
    </LegalPageLayout>
  )
}
